var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"file",attrs:{"type":"file"},on:{"change":_vm.change}}),_c('table',_vm._l((_vm.hashMap),function(value,key,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(key))]),_vm._l((value),function(v,k,i){return _c('td',{key:i},[_vm._v(" "+_vm._s(v)+" ")])})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }